/**
 * Vacancy overview — progressive enhancement.
 *
 * Without JS the filter form GETs back to the archive and pagination links are
 * real hrefs (handled server-side). This script upgrades that into in-place
 * AJAX filtering against the single REST endpoint: it swaps the card grid,
 * updates the live count and pagination, and syncs the URL (back/forward).
 *
 * Two reveal modes come from Theme Settings › Vacatures (cfg.mode):
 *   - "pagination" (default): numbered pages; each request REPLACES the grid.
 *   - "load_more": a "Laad meer vacatures" button that APPENDS the next page
 *     (cfg.perPage items) until the last page. The server still renders numbered
 *     links as the no-JS fallback; this script swaps them for the button.
 */
(function () {
  "use strict";

  var form = document.querySelector(".js-vacancy-filters");
  var grid = document.querySelector(".js-vacancy-grid");
  var countEl = document.querySelector(".js-vacancy-count");
  var pager = document.querySelector(".js-vacancy-pagination");
  var cfg = window.G4ZVacancyOverview;

  if (!form || !grid || !cfg || !cfg.endpoint) {
    return;
  }

  var mode = cfg.mode === "load_more" ? "load_more" : "pagination";
  var search = form.querySelector(".js-vacancy-search");
  var reset = document.querySelector(".c-vacancy-overview__reset");
  var paged = 1;
  var debounce;

  function hasActiveFilters() {
    if (search && search.value.trim()) {
      return true;
    }
    var active = false;
    form.querySelectorAll(".js-vacancy-facet").forEach(function (sel) {
      if (sel.value) {
        active = true;
      }
    });
    return active;
  }

  function syncReset() {
    if (!reset) {
      return;
    }
    reset.classList.toggle("is-visible", hasActiveFilters());
  }

  function buildParams() {
    var params = new URLSearchParams();
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (value) {
        params.set(key, value);
      }
    });
    if (paged > 1) {
      params.set("paged", String(paged));
    }
    return params;
  }

  function labelCount(n) {
    return n === 1
      ? "Er is 1 vacature die voldoet aan je filtercriteria"
      : "Er zijn " + n + " vacatures die voldoen aan je filtercriteria";
  }

  // Largest data-paged in the server-rendered numbered nav = total pages.
  function serverTotalPages() {
    var max = 1;
    pager.querySelectorAll("a[data-paged]").forEach(function (a) {
      var n = parseInt(a.getAttribute("data-paged"), 10) || 1;
      if (n > max) {
        max = n;
      }
    });
    return max;
  }

  function onLoadMore() {
    paged += 1;
    update({ append: true, push: false });
  }

  // Load-more mode: replace whatever is in the pager region with a single
  // button, shown only while pages remain.
  function renderLoadMore(totalPages) {
    pager.innerHTML = "";
    if (paged >= totalPages) {
      return;
    }
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "c-button c-button--secondary c-vacancy-overview__load-more js-vacancy-load-more";
    btn.textContent = cfg.loadMoreLabel || "Laad meer vacatures";
    btn.addEventListener("click", onLoadMore);
    pager.appendChild(btn);
  }

  function update(opts) {
    opts = opts || {};
    var append = opts.append === true;
    var push = opts.push !== false;
    var params = buildParams();
    var query = params.toString();
    grid.setAttribute("aria-busy", "true");

    fetch(cfg.endpoint + (query ? "?" + query : ""), {
      headers: { Accept: "application/json" },
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error("Vacancy request failed");
        }
        return res.json();
      })
      .then(function (json) {
        if (append) {
          grid.insertAdjacentHTML("beforeend", json.html);
        } else {
          grid.innerHTML = json.html;
        }
        if (countEl) {
          countEl.textContent = labelCount(json.count);
        }
        if (pager) {
          if (mode === "load_more") {
            renderLoadMore(json.total_pages);
          } else {
            pager.innerHTML = json.pagination_html || "";
          }
        }
        if (push !== false) {
          history.pushState({ vacancy: true }, "", query ? "?" + query : location.pathname);
        }
      })
      .catch(function () {
        /* keep the current results on failure */
      })
      .then(function () {
        grid.removeAttribute("aria-busy");
      });
  }

  // A filter change always resets to the first page and replaces the grid,
  // in both modes.
  function refilter() {
    paged = 1;
    syncReset();
    update();
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    refilter();
  });

  form.querySelectorAll(".js-vacancy-facet").forEach(function (select) {
    select.addEventListener("change", refilter);
  });

  if (search) {
    search.addEventListener("input", function () {
      clearTimeout(debounce);
      debounce = setTimeout(refilter, 350);
    });
  }

  // Numbered-paging clicks (pagination mode). In load-more mode the pager holds
  // the button instead, so this finds no link and no-ops.
  if (pager && mode !== "load_more") {
    pager.addEventListener("click", function (event) {
      var link = event.target.closest("a[data-paged]");
      if (!link) {
        return;
      }
      event.preventDefault();
      paged = parseInt(link.getAttribute("data-paged"), 10) || 1;
      update();
      form.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  if (reset) {
    reset.addEventListener("click", function (event) {
      event.preventDefault();
      if (search) {
        search.value = "";
      }
      form.querySelectorAll(".js-vacancy-facet").forEach(function (sel) {
        sel.value = "";
      });
      paged = 1;
      syncReset();
      update();
    });
  }

  window.addEventListener("popstate", function () {
    var sp = new URLSearchParams(location.search);
    if (search) {
      search.value = sp.get("zoek") || "";
    }
    form.querySelectorAll(".js-vacancy-facet").forEach(function (select) {
      select.value = sp.get(select.name) || "";
    });
    paged = parseInt(sp.get("paged"), 10) || 1;
    syncReset();
    update({ push: false });
  });

  // Load-more mode: swap the server's numbered fallback nav for the button.
  if (mode === "load_more" && pager) {
    renderLoadMore(serverTotalPages());
  }

  // Sync reset visibility for server-rendered pre-selected state.
  syncReset();
})();
